export default {
  computed: {
    pakMetaEndpoint() {
      // Root endpoint for retrieving PAK metadata and contents
      if (this.isDashboard && this.studentId) {
        return `/api/curriculum/admin/pak/${this.modulePakId}/users/${this.studentId}`;
      }
      return `/api/curriculum/pak/${this.modulePakId}`;
    },

    pakDownloadEndpoint() {
      if (this.isSolution) {
        // Endpoint for retrieving PAK solution contents - /tree and /file_content endpoints
        return `/api/curriculum/pak/${this.modulePakId}/solution`;
      }
      return this.pakMetaEndpoint;
    },
  },
};
